import {beDateFormat, beDatetimeFormat} from '@fl/cmsch-fe-library';
import moment, {Moment} from 'moment';

interface ControlYearInterval {
    startDate: Moment;
    endDate: Moment;
}

/**
 * Resolves the inclusive control-year interval used by milkability editing rules.
 *
 * @param controlDate Date that determines the active control-year window.
 * @returns The calculated start and end dates for the editable interval.
 */
export const getControlInterval = (controlDate: Moment): ControlYearInterval => {
    const previousControlYearSubtrahend = 2;
    const currentYear = controlDate.year();
    const actualDateIsAfterEndDate = controlDate.isAfter((moment(`${currentYear}-09-30`)));
    const addYear = actualDateIsAfterEndDate ? 1 : 0;
    const startDate = moment(`${currentYear - previousControlYearSubtrahend + addYear}-10-01`, beDateFormat);
    const endDate = moment(`${currentYear + addYear}-09-30`, beDateFormat);

    return {startDate, endDate};
};

/**
 * Checks whether a date belongs to the current or previous control year.
 *
 * @param date Date being validated.
 * @param controlDate Date that determines the active control-year window.
 * @returns `true` when the date is inside the two-control-year interval.
 */
export const isDateWithinTwoControlYears = (date: Moment, controlDate: Moment): boolean => {
    if (date.isValid() && controlDate.isValid()) {
        const {startDate, endDate} = getControlInterval(controlDate);

        return moment(date, beDatetimeFormat).isBetween(startDate, endDate, 'days', '[]');
    }

    return false;
};
